import { PrescriptionsList } from '@/components/prescriptions/PrescriptionsList';
import { Stack, Typography } from '@montugroup/design-system';

export function Prescriptions() {
  return (
    <Stack gap={5} flexGrow={1}>
      <Typography variant="h5" fontWeight={'700'} color="primary">
        Prescriptions
      </Typography>
      <PrescriptionsList />
    </Stack>
  );
}
